import { PhoneField } from "components/phone-field";
import { Typography } from "components/typography";
import type { PsychologistProfile } from "core/types";
import { useTranslation } from "react-i18next";
import { useCurrentUser } from "hooks/userHooks";
import { type PhoneFieldChangeValue } from "components/phone-field";
import { ChangeEvent } from "react";

type Props = {
  psychologist: Pick<PsychologistProfile, "phone">;
  psychologistValidation: string[];
  onChange: (
    x: string,
  ) => (arg: PhoneFieldChangeValue | ChangeEvent<HTMLInputElement>) => void;
};

const EditablePhoneAndUneditableEmail = ({
  psychologist,
  psychologistValidation,
  onChange,
}: Props) => {
  const { t } = useTranslation();
  const { user } = useCurrentUser();

  return (
    <div>
      <PhoneField
        value={psychologist.phone ?? ""}
        sensitive={true}
        label={`${t("PHONE_NUMBER")}*`}
        onChange={onChange("phone")}
        error={psychologistValidation.indexOf("phone") !== -1}
        errorMessage={t("PHONE_NUMBER_NOT_VALID")}
      />
      <div>
        <Typography variant="body-x-small" color="GRAY_DARK">
          {t("EMAIL")}
        </Typography>
        <Typography
          variant="body"
          style={{ marginTop: "10px", marginBottom: "0" }}
        >
          {user?.email}
        </Typography>
      </div>
    </div>
  );
};

export default EditablePhoneAndUneditableEmail;
